<template>
  <div class="overlay-news" :class="isOpenOverlay ? 'open' : ''">
    <div class="overlay-head">
      <div class="back-btn" @click="close">
        <img src="../../assets/images/arrow-back@2x.png" />
        <p>Back</p>
      </div>
    </div>
    <div class="overlay-body">
      <div class="content">
        <div class="border-grid"></div>
        <h3
          class="title"
          v-html="$t('message.news')[indexNews].overlay_title"
        ></h3>
        <p
          class="subtitle"
          v-html="$t('message.news')[indexNews].overlay_subtitle"
        ></p>
        <p class="text" v-html="$t('message.news')[indexNews].overlay_text"></p>
        <img
          v-if="$t('message.news')[indexNews].overlay_img_extra.length > 0"
          :src="
            require('../../assets/images/' +
              $t('message.news')[indexNews].overlay_img_extra)
          "
          class="img-webinar"
        />
        <p
          v-if="$t('message.news')[indexNews].overlay_text_extra.length > 0"
          class="text"
          v-html="$t('message.news')[indexNews].overlay_text_extra"
        ></p>
        <img
          v-if="$t('message.news')[indexNews].overlay_img.length > 0"
          :src="
            require('../../assets/images/' +
              $t('message.news')[indexNews].overlay_img)
          "
          class="img-webinar"
        />
        <div
          class="download"
          v-if="$t('message.news')[indexNews].overlay_filename.length > 0"
        >
          <a
            :href="$t('message.news')[indexNews].overlay_filename_path"
            download
          >
            <img src="../../assets/images/download-icon@2x.png" />
            <p>{{ $t("message.news")[indexNews].overlay_filename }}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverlayNews",
  props: ["isOpenOverlay", "toggleOpenOverlay", "indexNews"],
  methods: {
    close() {
      return this.$emit("toggleOpenOverlay", this.indexNews);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" >
.overlay-news {
  position: fixed;
  width: 100%;
  max-height: 100vh;
  top: 100%;
  z-index: 10;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  transition: top 0.75s ease-in-out;
  &.open {
    top: 0;
  }
  .overlay-head {
    position: absolute;
    top: 0;
    width: 100%;
    height: 70px;
    background: #f5f5f5;
    z-index: 10;
    border: 1px solid rgba($color: #000000, $alpha: 0.05);
    .back-btn {
      height: 100%;
      border-right: 1px solid rgba($color: #000000, $alpha: 0.05);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 150px;
      cursor: pointer;
      @media screen and (max-width: 1100px) {
        width: 15%;
      }
      @media screen and (max-width: 900px) {
        width: 150px;
      }
      img {
        width: 20px;
      }
      p {
        color: rgba($color: #000000, $alpha: 0.25);
        font-weight: 400;
        margin-left: 20px;
      }
    }
  }
  .overlay-body {
    position: absolute;
    top: 70px;
    overflow: hidden;
    overflow-y: scroll;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
  }
}
.border-grid {
  position: absolute;
  height: 100%;
  width: 100%;
  pointer-events: none;
  border-left: 1px solid rgba($color: #000000, $alpha: 0.05);
  border-right: 1px solid rgba($color: #000000, $alpha: 0.05);
  .inner-line {
    display: none;
    position: absolute;
    left: 50%;
    height: 100%;
    border-left: 1px solid rgba($color: #000000, $alpha: 0.05);
  }
}
.content {
  position: relative;
  margin: 0 25%;
  @media screen and( max-width: 1100px) {
    margin: 0 15%;
  }
  @media screen and( max-width: 900px) {
    margin: 0 20px;
  }
  h3 {
    padding-top: 75px;
    font-size: 60px;
    line-height: 74px;
    font-weight: 700;
    margin-bottom: 20px;
    @media screen and (max-width: 1100px) {
      line-height: 50px;
      font-size: 40px;
    }
    @media screen and (max-width: 900px) {
      line-height: 37px;
      font-size: 30px;
    }
  }
  p {
    font-size: 16px;
    line-height: 30px;
    a {
      text-decoration: underline;
    }
  }
  p.subtitle {
    font-style: italic;
    margin-bottom: 100px;
    @media screen and (max-width: 900px) {
      margin-bottom: 50px;
    }
  }
  img {
    display: block;
    width: 100%;
    margin-bottom: 16px;
  }
}
.download {
  width: 100%;

  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  padding: 70px 0 150px;
  cursor: pointer;
  img {
    width: 20px;
  }
  p {
    text-decoration: underline;
    margin-left: 20px;
  }
}
.img-webinar {
  width: 650px;
  margin: 60px auto;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// OverlayNews.vue?494fa2d1